(function($){
    function logElementEvent(eventName, element) {
        if($('body').hasClass('special-offers-page')){
            $('.offers-container').imagesLoaded().progress( function(instance, element) {
                if(element){
                    $('.offers-container').isotope('layout');
                }
            });
        }
    }

    var callback_enter = function (element) {
        logElementEvent("🔑 ENTERED", element);
    };

    window.lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        threshold: 100,
        callback_enter: callback_enter,
    });

    function sofitel_getScrollbarWidth() {
        var outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
        document.body.appendChild(outer);
        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = "scroll";
        // add innerdiv
        var inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        // remove divs
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    }

    function sofitel_refresh_size_queries() {
        var classes = [];
        var scrollbarwidth = sofitel_getScrollbarWidth();
        window_width = $(window).width() + scrollbarwidth;
        window_height = $(window).height();
        is_phone = (window_width < 768);
        is_mobile = (window_width < 992);
        is_tablet_portrait = (window_width >= 768 && window_width < 992);
        is_tablet_landscape = (window_width >= 992 && window_width < 1200 && window_height <= 768);
        is_tablet = is_tablet_portrait || is_tablet_landscape;
        is_desktop = (window_width >= 992);
        is_desktop_large = (window_width >= 1200);

        if (is_phone) {
            classes.push('mq_phone');
        }
        if (is_mobile) {
            classes.push('mq_mobile');
        }
        if (is_tablet_portrait) {
            classes.push('mq_tablet_portrait');
        }
        if (is_tablet_landscape) {
            classes.push('mq_tablet_landscape');
        }
        if (is_tablet) {
            classes.push('mq_tablet');
        }
        if (is_desktop) {
            classes.push('mq_desktop');
        }
        if (is_desktop_large) {
            classes.push('mq_desktop_large');
        }


        $('html').removeClass('mq_phone');
        $('html').removeClass('mq_mobile');
        $('html').removeClass('mq_tablet_portrait');
        $('html').removeClass('mq_tablet_landscape');
        $('html').removeClass('mq_tablet');
        $('html').removeClass('mq_desktop');

        $('html').addClass(classes.join(' '));

    }

    function sofitel_default_fancybox(){
        $('[data-fancybox]:not(.slick-cloned)').fancybox({
            buttons: [
                "close"
            ]
        });
    }

    function sofitel_header_position(){
        var scroll = $(window).scrollTop(),
            header_wrapper = $('.header-wrapper'),
            header_menu = $('#header_menu_container'),
            slideshow = $('#slideshow_wrapper'),
            breakpoint = (slideshow.height() - header_menu.height());
            if($('html').hasClass('home')){
                if (scroll >= breakpoint) {
                    header_menu.addClass('fixed');
                } else {
                    header_menu.removeClass('fixed');
                }
            } else {
                if (scroll > 0) {
                    header_wrapper.addClass('fixed');
                    header_menu.addClass('fixed');
                } else {
                    header_wrapper.removeClass('fixed');
                    header_menu.removeClass('fixed');
                }
            }
    }

    function sofitel_language_manager_on_focus() {
        //This function is for accessibility
        document.addEventListener("keydown", function(event) {
            if(event.which === 9){
                $('.language_selector a.current_language').focus(function () {
                    $('.other_languages').css({
                        'display': 'block',
                    });
                });
                $('.other_languages li:last-child a').focusout(function(){
                    $('.other_languages').removeAttr('style');
                });


                $('.menu .menu-item a').focus(function () {
                    $(this).next().css({
                        'display': 'block',
                    });
                });
                $('.sub-menu li:last-child a').focusout(function(){
                    $('.sub-menu').fadeOut();
                });
            }
        });
    }

    function sofitel_back_to_top(){
        $(window).scroll(function(){
            if ($(this).scrollTop() > 100) {
                $('.back-to-top').addClass('show');
            } else {
                $('.back-to-top').removeClass('show');
            }
        });
        $(".back-to-top").click(function( event) {
            event.preventDefault();
            $(document).off("scroll");
            $("html, body").animate(
                {scrollTop: 0},
                1000);

            $('.skip-to-content').focus();
        });
    }

    function sofitel_sidebarmenu() {
        var link = $('.open_sidebar_menu');
        var wrap = $('#menu_sidebar_wrap');
        var close = wrap.find('.close_sidebar');

        if (link.length > 0 && wrap.length > 0) {

            var submenus = wrap.find('.menu-item-has-children');
            submenus.each(function(){
                $(this).append('<span class="dropdown"></span>');
            });
            submenus.find('.dropdown').click(function () {
                $(this).toggleClass('rotate');
                $(this).prev().slideToggle();
            });


            link.click(function (e) {
                wrap.addClass('open');
                setTimeout(function () {
                    wrap.addClass('visible');
                }, 300);
                $('html').addClass('no-scroll');
            });
            link.on('keypress', function(){
                wrap.find('.current-menu-item a').focus();
            });

            close.click(function () {
                wrap.removeClass('visible');
                setTimeout(function () {
                    wrap.removeClass('open');
                }, 300);
                $('html').removeClass('no-scroll');
            });
        }
    }

    function sofitel_slideshow(){
        var slideshow_container = $('#slideshow_wrapper');
        if(slideshow_container.length > 0){

            $('.slideshow').not('.slick-initialized').slick({
                rows: 0,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<a href="javascript:;" class="arrow inverse prev slick-prev" aria-label="'+ previous_image_text + '"><span></span></a>',
                nextArrow: '<a href="javascript:;" class="arrow inverse next slick-next" aria-label="'+ next_image_text + '"><span></span></a>',
            });

            $('.slideshow').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

                var slideIndexToPreload = (nextSlide > currentSlide ? nextSlide : currentSlide - 1) ;
                var slideToPreload = $(slick.$slides.get(slideIndexToPreload ));
                var slideToPreloadPicture = slideToPreload.find('picture');

                $(slideToPreloadPicture).each(function () {

                    var slideToPreloadSourceSets = $(this).find('source');
                    var slideToPreloadImg = $(this).find('img');
                    if(slideToPreloadImg.data('load') === 'no-loaded'){

                        slideToPreloadSourceSets.attr('srcset', slideToPreloadSourceSets.data('lazy-srcset')).removeAttr('data-lazy-srcset');
                        slideToPreloadImg .attr('data-load', 'loaded');

                    } else {

                        return;

                    }

                });
            });
        }
    }

    // function sofitel_double_char( elmts ) {
    //     $(elmts).each(function() {
    //         var paragraph = $(this).text().length;
    //         var paragraph_array = $(this).text().split('');
    //         var paragraph_string = paragraph / 2;
    //         var number = parseInt(paragraph_string.toString(), 10) - 1;
    //         var array = ['a', 'b', 'd', 'e', 'o', 'p', 'q', 'r', 'u', 'y'];
    //         if (typeof paragraph_array[number] === 'undefined') {
    //             return;
    //         }
    //
    //         if( array.indexOf( paragraph_array[number].toLowerCase() ) > -1 ) {
    //             paragraph_array[number] = '<span class="double double-'+paragraph_array[number].toLowerCase()+'">'+paragraph_array[number] +'</span>';
    //         } else {
    //             for(var i = 0; i <= number; i++) {
    //                 if(array.indexOf(paragraph_array[number - i].toLowerCase()) > -1) {
    //                     paragraph_array[number - i] = '<span class="double double-'+paragraph_array[number -i].toLowerCase()+'">'+paragraph_array[number - i] +'</span>';
    //                     break;
    //                 } else if(array.indexOf(paragraph_array[number + i].toLowerCase()) > -1) {
    //                     paragraph_array[number + i] = '<span class="double double-'+paragraph_array[number + i].toLowerCase()+'">'+paragraph_array[number + i] +'</span>';
    //                     break;
    //                 }
    //             }
    //         }
    //
    //         paragraph_array = paragraph_array.join('');
    //         $(this).html(paragraph_array);
    //     });
    // }

    function sofitel_general_section(){
        var general_section = $('#general_section, #generic_home_section, #rooms_section');
        if(general_section.length > 0){
            $('.single-section ').each(function(index){
                var minigallery = $(this).find('.thumb-wrap');
                minigallery.each(function(){
                    var children = $(this).children();
                    if($(this).length > 0){
                        if(children.length > 1){
                            $(this).on('init', function(){
                                lazyLoadInstance.update();
                            });
                            $(this).not('.slick-initialized').slick({
                                rows: 0,
                                slide: '.single-img',
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                                prevArrow: '<a href="javascript:;" class="arrow inverse prev slick-prev" aria-label="'+ previous_image_text + '"><span></span></a>',
                                nextArrow: '<a href="javascript:;" class="arrow inverse next slick-next" aria-label="'+ next_image_text + '"><span></span></a>',
                            });
                        }
                    }
                });
            });
        }
    }

    function sofitel_additional_section(){
        var additional_section = $('.additional-section');
        if(additional_section.length > 0){
            var additional_section_container = $('#additional_section_container');
            var minigallery = additional_section_container.find('.thumb-wrap'),
            children = minigallery.children();
            if(minigallery.length > 0){
                if(children.length > 1){
                    minigallery.on('init', function(){
                        lazyLoadInstance.update();
                    });
                    minigallery.not('.slick-initialized').slick({
                        rows: 0,
                        slide: '.single-img',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        prevArrow: '<a href="javascript:;" class="arrow inverse prev slick-prev" aria-label="'+ previous_image_text + '"><span></span></a>',
                        nextArrow: '<a href="javascript:;" class="arrow inverse next slick-next" aria-label="'+ next_image_text + '"><span></span></a>',
                    });
                }
            }
        }
    }

    function sofitel_exhibition_carousel(){
        var exhibition_carousel = $('.exhibition-carousel'),
            children = exhibition_carousel.children(),
            hasCarousel = false;
        if(exhibition_carousel.length > 0){
            if(is_mobile && children.length > 0){
                hasCarousel = true;
            } else{
                if(children.length > 3){
                    hasCarousel = true;
                }
            }
            if(hasCarousel){
                exhibition_carousel.on('init', function(){
                    lazyLoadInstance.update();
                });
                exhibition_carousel.not('.slick-initialized').slick({
                    rows:0,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                    dotsClass: 'slick-dots inverse',
                    prevArrow: '<a href="javascript:;" class="arrow inverse prev slick-prev" aria-label="'+ previous_offer_text + '"><span></span></a>',
                    nextArrow: '<a href="javascript:;" class="arrow inverse next slick-next" aria-label="'+ next_offer_text + '"><span></span></a>',
                    responsive:[
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            }
        }
    }

    function sofitel_offers_carousel(){
        var offers_carousel = $('.offers-carousel'),
            children = offers_carousel.children(),
            hasCarousel = false;
        if(offers_carousel.length > 0){
            if(is_mobile && children.length > 0){
                hasCarousel = true;
            } else{
                if(children.length > 3){
                    hasCarousel = true;
                }
            }
            if(hasCarousel){
                offers_carousel.on('init', function(){
                    lazyLoadInstance.update();
                });
                offers_carousel.not('.slick-initialized').slick({
                    rows:0,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                    dotsClass: 'slick-dots inverse',
                    prevArrow: '<a href="javascript:;" class="arrow inverse prev slick-prev" aria-label="'+ previous_offer_text + '"><span></span></a>',
                    nextArrow: '<a href="javascript:;" class="arrow inverse next slick-next" aria-label="'+ next_offer_text + '"><span></span></a>',
                    responsive:[
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            }
        }
    }

    function sofitel_special_offers(){
        if($('body').hasClass('special-offers-page')){
            var special_offers_container = $('.offers-container'),
                selector = $('#filter-offers');

            special_offers_container.isotope({
                layoutMode:'fitRows',
                itemSelector: '.single-offer'
            });

            selector.on('change', function(){
                var value = $(this).val() === 'all' ? "*" : $(this).val();
                special_offers_container.isotope({ filter: value });
            });
        }
    }

    function sofitel_book_offer() {
        $('.bookable-offer').on('click', function () {
            var offer_code = $(this).attr('data-offer-code');
            if( typeof offer_code != 'undefined'){
                var args = { preferredCode: offer_code  };
                accorBookNow(args);
            }
        });
    }

    function sofitel_initialize_map() {
        if ($('body').hasClass('homepage')) {
            if (typeof (div) === "undefined") div = "map_canvas";
            if (typeof (bounds) === "undefined" && map_data.set_bounds) bounds = new google.maps.LatLngBounds();
            var marker, i;

            var infoWindow = new google.maps.InfoWindow({
                'maxWidth': 500,
                'maxHeight': 400,
                'autoScroll': true
            });

            center = [map_data.markers[0].latitude, map_data.markers[0].longitude];

            map = new google.maps.Map(document.getElementById(div), {
                // scroll wheel
                scrollwheel: false,
                //zoom
                zoom: map_data.map_zoom,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_BOTTOM
                },
                //position
                center: new google.maps.LatLng(center[0], center[1]),
                //map type
                mapTypeId: google.maps.MapTypeId['roadmap'],
                mapTypeControl: true,
                mapTypeControlOptions: {
                    position: google.maps.ControlPosition.TOP_RIGHT,
                    style: google.maps.MapTypeControlStyle.DEFAULT
                },
                // default pan control
                panControl: false,
                panControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                // scale control - image with the scale index (m,km,etc)
                scaleControl: false,
                scaleControlOptions: {
                    position: google.maps.ControlPosition.TOP_RIGHT
                },
                // 	streetview controls
                streetViewControl: true,
                streetViewControlOptions: {
                    position: google.maps.ControlPosition.TOP_RIGHT
                }

            });

            var styles = [
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-100"
                        },
                        {
                            "lightness": "0"
                        }
                    ]
                },
                {
                "featureType": "poi.business",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-50"
                        }
                    ]
                }
            ];
            map.setOptions({styles: styles});

            for (i = 0; i < map_data.markers.length; i++) {

                if (i === 0) {
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(map_data.markers[0].latitude, map_data.markers[0].longitude),
                        map: map,
                        icon: map_data.markers[0].icon_hotel,
                        zIndex:99999999
                    });
                }
            }
        }
    }

    function sofitel_tripadvisor_carousel(){
        var tripadvisor_carousel = $('.tripadvisor-carousel');
        if(tripadvisor_carousel.length > 0){
            tripadvisor_carousel.on('init', function(){
                lazyLoadInstance.update();
            });
            tripadvisor_carousel.not('.slick-initialized').slick({
                rows:0,
                slidesToShow:3,
                slidesToScroll:1,
                prevArrow: '<a href="javascript:;" class="arrow prev slick-prev" aria-label="'+ previous_review_text + '"><span></span></a>',
                nextArrow: '<a href="javascript:;" class="arrow next slick-next" aria-label="'+ next_review_text + '"><span></span></a>',
                responsive:[
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    }

    function sofitel_instagram_feeds(){
        if($('body').hasClass('homepage')){
            var instagram_feeds_container = $('.social-media-widget');
            if(instagram_feeds_container.length > 0){
                var instagram_feeds = document.querySelector('.social-media-widget');
                observer = new IntersectionObserver(function(entry, observer){
                    if(entry[0].intersectionRatio > 0){
                        $('.social-media-widget').append(JSON.parse($('#instagram_data').text()));
                        sbi_init();
                        observer.unobserve(instagram_feeds);
                    }
                });
                observer.observe(instagram_feeds);
            }
        }
    }

    function sofitel_handler_map(){
        if($('body').hasClass('homepage')){
            var map_container = document.querySelector('.map-container');
            observer = new IntersectionObserver(function(entry, observer){
                if(entry[0].intersectionRatio > 0){
                    sofitel_initialize_map();
                    observer.unobserve(map_container);
                }
            });
            observer.observe(map_container);
        }
    }

    //submit form contact
    function sofitel_hotel_form() {
        var form_initial = $('#hotel_form');
        if (form_initial.length===0) return false;

        form_initial.submit(function (event) {
            event.preventDefault();
            // disable form
            form_initial.addClass('disabled');
            form_initial.find('input[type=submit]').prop('disabled', true);
            // Serialize the form data.
            var formData = form_initial.serialize();
            //
            $.ajax({
                type: 'POST',
                url: sofitel_ajax_url,
                data: formData,
                dataType: "json",
                success: function (response) {
                    form_initial.find('.field.alert').removeClass('alert');
                    if (response.error) {
                        for (var i = 0; i < response.details.length; i++) {
                            var error = response.details[i];
                            if(error['field'] === "customer_surname_hotel") {
                                $('#hotel_form_box').find('.message_error.hide').fadeIn("slow", function() {
                                    $('#hotel_form_box').find('.message_error.hide').attr("style", "display: block !important");
                                });
                                form_initial.fadeOut();
                                return false;
                            } else {
                                var single_field = form_initial.find('.field.' + error.field);
                                single_field.addClass('alert');
                                single_field.find('.error').text(error.details);
                            }
                        }
                        // enable form
                        form_initial.removeClass('disabled');
                        form_initial.find('input[type=submit]').prop('disabled', false);
                    } else {
                        // success print
                        $('#hotel_form_box').find('.message_box.hide').removeClass('hide');
                        form_initial.fadeOut();
                    }

                },
                fail: function (err) {
                    console.log('error');
                    alert("There was an error: " + err);
                }
            });
        });
    }



    //window load
    $(window).load(function () {
        sofitel_refresh_size_queries();
    });

    //window resize
    $(window).resize(function () {
        sofitel_refresh_size_queries();
    });

    //Dom ready
    $(document).ready(function () {
        sofitel_refresh_size_queries();
        sofitel_default_fancybox();
        sofitel_header_position();
        sofitel_language_manager_on_focus();
        sofitel_back_to_top();
        sofitel_sidebarmenu();
        sofitel_slideshow();
        // double characters
        // sofitel_double_char( 'h1, .title-section');
        sofitel_general_section();
        sofitel_additional_section();
        sofitel_exhibition_carousel();
        sofitel_offers_carousel();
        sofitel_tripadvisor_carousel();
        sofitel_instagram_feeds();

        sofitel_handler_map();
        sofitel_book_offer();
        sofitel_special_offers();
        if($('body').hasClass('contact-page')) {
            sofitel_hotel_form();
        }
        window.onscroll = function () {
            sofitel_header_position();
        };
        $('.reservation, .bookable, #book_now').on('click', function(){
            accorBookNow();
        });
    });
})(jQuery);